import { Routes } from '@angular/router';
import { dbUserGuard } from './shared/guards/db-user.guard';
import { dbUserResolver } from './shared/resolvers/db-user.resolver';
import { redirectLoggedInGuard } from './shared/guards/redirect-logged-in.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/home/home.routes').then((mod) => mod.HOME_ROUTES),
  },
  {
    path: 'rsvp',
    loadChildren: () => import('./features/rsvp/rsvp.routes').then((mod) => mod.RSVP_ROUTES),
  },
  {
    path: 'guide',
    loadChildren: () => import('./features/guide/guide.routes').then((mod) => mod.GUIDE_ROUTES),
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((mod) => mod.AUTH_ROUTES),
    canActivate: [redirectLoggedInGuard],
  },
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then((mod) => mod.ADMIN_ROUTES),
    canActivate: [dbUserGuard],
    resolve: {
      user: dbUserResolver,
    },
  },
];
